import moduleRegistry from '../module-registry/module-registry';

const config = {
    selectors: {
        root: '.detail-form',
        titles: '.detail-form__titles',
        titleInput: '.detail-form__title-input',
        selectItems: '.detail-form__select-items',
    },
    classNames: {
        customTitle: 'detail-form__title-input--custom-title',
        customselect: 'detail-form__custom-select',
        selectSelected: 'detail-form__select-selected',
        selectSelectedActive: 'detail-form__select-selected--active',
        selectItems: 'detail-form__select-items',
        selectItemsHide: 'detail-form__select-hide',
        selectItem: 'detail-form__select-item',
        sameAsSelected: 'detail-form__same-as-selected',
        customTitle: 'detail-form__title-input--custom-title',
    },
};


class DetailForm {

    constructor($rootElement) {
        this._$rootElement = $rootElement;
        this._elements = null;
    }

    init() {
        this._elements = this._getDomElements();
        this._addEventListeners();
        this._generateSelect();
    }

    _getDomElements() {
        return {
            $titles: this._$rootElement.find(config.selectors.titles),
            $titleInput: this._$rootElement.find(config.selectors.titleInput),
            $selectItems: this._$rootElement.find(config.selectors.selectItems)
        };
    }

    _addEventListeners() {
        const _this = this;

        this._elements.$titles.on("change", function() {
            const $titleInput = $(_this._elements.$titleInput);
            if($(this).val() === "other") {
                $titleInput.addClass(config.classNames.customTitle);
            } else {
                $titleInput.removeClass(config.classNames.customTitle);
            }
        });
    }

    _generateSelect() {
   
        var customSelect, i, j, customSelectLength, selectLength, selElmnt, selectSelected, selectItems, selectItem;
        /* look for any elements with the class "custom-select": */
        customSelect = this._$rootElement.find('.detail-form__custom-select');
        customSelectLength = customSelect.length;
        // console.log("customSelect", customSelect)

        // WICHTIG: in detail-form rein und nicht mit document

        for (i = 0; i < customSelectLength; i++) {
            selElmnt = customSelect[i].getElementsByTagName('select')[0];
            selectLength = selElmnt.length;
            /* for each element, create a new DIV that will act as the selected item: */
            selectSelected = document.createElement('DIV');
            selectSelected.setAttribute('class', config.classNames.selectSelected);
            selectSelected.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
            customSelect[i].appendChild(selectSelected);
            /* for each element, create a new DIV that will contain the option list: */
            selectItems = document.createElement('DIV');
            selectItems.setAttribute('class', config.classNames.selectItems);
            selectItems.classList.add(config.classNames.selectItemsHide);
            for (j = 1; j < selectLength; j++) {
                /* for each option in the original select element,
                create a new DIV that will act as an option item: */
                selectItem = document.createElement('DIV');
                selectItem.setAttribute('class', config.classNames.selectItem);
                selectItem.innerHTML = selElmnt.options[j].innerHTML;

                const $this = this;
                selectItem.addEventListener('click', function (e) {
                    /* when an item is clicked, update the original select box,
                    and the selected item: */
                    var sameAsSelectedItem, i, k, defaultSelect, selectedItem, sl, yl;
                    defaultSelect = this.parentNode.parentNode.getElementsByTagName('select')[0];
                    sl = defaultSelect.length;
                    selectedItem = this.parentNode.previousSibling;
                    for (i = 0; i < sl; i++) {
                        if (defaultSelect.options[i].innerHTML === this.innerHTML) {
                            defaultSelect.selectedIndex = i;
                            // console.log('ok');
                            const $customSelect = $this._$rootElement.find(config.classNames.customselect);
                            const hiddenSelect = $customSelect.find('select');
                            hiddenSelect.val(this.innerHTML);
                            selectedItem.innerHTML = this.innerHTML;
                            sameAsSelectedItem = this.parentNode.getElementsByClassName(config.classNames.sameAsSelected);
                            yl = sameAsSelectedItem.length;
                            for (k = 0; k < yl; k++) {
                                sameAsSelectedItem[k].removeAttribute('class');
                            }
                            this.setAttribute('class', config.classNames.sameAsSelected);
                            break;
                        }
                    }
                    selectedItem.click();
                });
                selectItems.appendChild(selectItem);
            }
            customSelect[i].appendChild(selectItems);
          
            selectSelected.addEventListener('click', function (e) {
                /* when the select box is clicked, close any other select boxes,
                and open/close the current select box: */
                 e.stopPropagation();
                 
              const nextsibling = this.nextSibling;
              var selecteditems = $(config.selectors.selectItems)
              selecteditems.addClass(config.classNames.selectItemsHide)
              nextsibling.classList.toggle(config.classNames.selectItemsHide);
            });
        }
        
        /* if the user clicks anywhere outside the select box,
        then close all select boxes: */
        document.addEventListener('click', this._closeAllSelects);
    }

   

    _closeAllSelects() {
        var selecteditems = $(config.selectors.selectItems)
        selecteditems.addClass(config.classNames.selectItemsHide)
    }

}

moduleRegistry.registerModule('DetailForm', DetailForm);
moduleRegistry.autoApplyModule('DetailForm', config.selectors.root);